export const productFamilies = [
    { key: "Microsoft Purview", name: "Microsoft Purview" },
    { key: "Microsoft Defender", name: "Microsoft Defender" },
    { key: "Microsoft Entra", name: "Microsoft Entra" },
    { key: "Microsoft Intune", name: "Microsoft Intune" },
    // { key: "Microsoft Sentinel", name: "Microsoft Sentinel" },
    { key: "Microsoft Priva", name: "Microsoft Priva" },
    { key: "Security Copilot", name: "Security Copilot" },
    // { key: "Cloud Security", name: "Cloud Security" }
];
